import { SagisConfig } from 'containers/AppContainer/typings';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';
import { translate } from 'containers/services/translate';
import messages from 'containers/CourtManagerLegalProceedings/Provision/Regulation/messages';
import { get, isNil } from 'lodash';
import {
  getBeneficiaryByRisk,
  getCurrentSheet,
  getEncryptedTypeDocument,
  getRiskType,
} from 'containers/CourtManagerLegalProceedings/Provision/Regulation/utils';
import moment from 'moment-timezone';
import { DATE_FORMAT } from 'constants/global';
import AssignmentIcon from '@material-ui/icons/Assignment';
import DetailsIcon from '@material-ui/icons/Details';
import { openDocument } from 'containers/UploadDocuments/utils';
import { SHEETS } from 'containers/CourtManagerLegalProceedings/Provision/Regulation/constants';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';

export interface RegulationTableProps {
  allRegulations: any[];
  sagisClaim: any;
  listings: any;
  regulations: any;
  isConsultation: boolean;
  setOpenRecap: Function;
  setPaymentId: Function;
}

const RegulationTable: React.FC<RegulationTableProps> = ({
  allRegulations,
  sagisClaim,
  listings,
  regulations,
  isConsultation,
  setOpenRecap,
  setPaymentId,
  ...props
}) => {
  const isSagisRegulation = (paymentId: string): boolean => {
    const regulationsPaymentIds = regulations.map(
      (regulation: any) => regulation.sagisRegulationId,
    );
    return !regulationsPaymentIds.includes(paymentId);
  };

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell align="left" className="headerTitle">
            {translate({ ...messages.riskName }, props)}
          </TableCell>
          <TableCell align="left" className="headerTitle">
            {translate({ ...messages.regulationDate }, props)}
          </TableCell>
          <TableCell align="left" className="headerTitle">
            {translate({ ...messages.beneficiary }, props)}
          </TableCell>
          <TableCell align="left" className="headerTitle">
            {translate({ ...messages.recipient }, props)}
          </TableCell>
          <TableCell align="left" className="headerTitle">
            {translate({ ...messages.realBeneficiary }, props)}
          </TableCell>
          <TableCell align="left" className="headerTitle">
            {translate({ ...messages.beneficiaryReference }, props)}
          </TableCell>
          <TableCell align="left" className="headerTitle">
            {translate({ ...messages.documentType }, props)}
          </TableCell>
          <TableCell align="left" className="headerTitle">
            {translate({ ...messages.regulationPhase }, props)}
          </TableCell>
          <TableCell align="left" className="headerTitle">
            {translate({ ...messages.paymentChannel }, props)}
          </TableCell>
          <TableCell align="left" className="headerTitle">
            {translate({ ...messages.paymentRegulation }, props)}
          </TableCell>
          <TableCell align="left" className="headerTitle">
            {translate({ ...messages.statusRegulation }, props)}
          </TableCell>
          <TableCell align="left" className="headerTitle">
            {translate({ ...messages.town }, props)}
          </TableCell>{' '}
          <TableCell align="left" className="headerTitle">
            {translate({ ...messages.additionalAddress }, props)}
          </TableCell>
          <TableCell align="left" className="headerTitle">
            {translate({ ...messages.totalAmount }, props)}
          </TableCell>{' '}
          <TableCell align="left" className="headerTitle">
            {translate({ ...messages.validator }, props)}
          </TableCell>
          <TableCell align="left" className="headerTitle">
            {translate({ ...messages.summarySheet }, props)}
          </TableCell>
          <TableCell align="left" className="headerTitle">
            {translate({ ...messages.cdraOrCnraSheet }, props)}
          </TableCell>
          {featureService.hasFeature(
            FEATURES.REGULATION_WORKFLOW_VALIDATION,
          ) && (
            <TableCell align="left" className="headerTitle">
              {translate({ ...messages.regulationRecap }, props)}
            </TableCell>
          )}
        </TableRow>
      </TableHead>
      {allRegulations.map((risk: any) => {
        return (
          <TableBody key={risk.riskId}>
            <TableRow id="table-row">
              <TableCell align="left" className="row">
                {getRiskType(sagisClaim, risk)}
              </TableCell>
              <TableCell align="left" className="row">
                {moment(get(risk, 'regulationDate', '')).format(DATE_FORMAT)}
              </TableCell>
              <TableCell align="left" className="row">
                {getBeneficiaryByRisk(
                  sagisClaim,
                  get(risk, 'beneficiaryCode', ''),
                )}
              </TableCell>
              <TableCell align="left" className="row">
                {get(risk, 'recipient', '')}
              </TableCell>
              <TableCell align="left" className="row">
                {get(risk, 'realBeneficiary', '')}
              </TableCell>
              <TableCell align="left" className="row">
                {get(risk, 'beneficiaryReference', '')}
              </TableCell>
              <TableCell align="left" className="row">
                {getEncryptedTypeDocument(
                  sagisClaim,
                  get(risk, 'documentTypeCode', ''),
                )}
              </TableCell>
              <TableCell align="left" className="row">
                {get(
                  get(listings, 'PaymentNature', []).find(
                    (item: SagisConfig) =>
                      item.ItemKey === get(risk, 'PaymentNatureCode', ''),
                  ) || {},
                  'ItemDescription',
                  '',
                )}
              </TableCell>
              <TableCell align="left" className="row">
                {get(
                  get(listings, 'PaymentChannel', []).find(
                    (item: SagisConfig) =>
                      item.ItemKey === get(risk, 'PaymentChannelCode', ''),
                  ) || {},
                  'ItemDescription',
                  '',
                )}
              </TableCell>
              <TableCell align="left" className="row">
                {get(
                  get(listings, 'PaymentMethod', []).find(
                    (paymentMethod: SagisConfig) =>
                      paymentMethod.ItemKey === risk.paymentModeCode,
                  ) || {},
                  'ItemDescription',
                  '',
                )}
              </TableCell>
              <TableCell align="left" className="row">
                {get(
                  get(listings, 'PaymentStatus', []).find(
                    (paymentMethod: SagisConfig) =>
                      paymentMethod.ItemKey === risk.paymentStatusCode,
                  ) || {},
                  'ItemDescription',
                  '',
                )}
              </TableCell>
              <TableCell align="left" className="row">
                {get(
                  get(listings, 'villes', []).find(
                    (item: SagisConfig) =>
                      item.ItemKey === get(risk, 'townCode', ''),
                  ) || {},
                  'ItemDescription',
                  '',
                )}
              </TableCell>
              <TableCell>{get(risk, 'adressRecipient', '')}</TableCell>
              <TableCell>
                {get(risk, 'paidAmount') === 0
                  ? get(risk, 'amount', '')
                  : get(risk, 'paidAmount', '')}
              </TableCell>
              <TableCell>{get(risk, 'gestionnaire', '')}</TableCell>
              <TableCell>
                {!isNil(
                  getCurrentSheet(
                    regulations,
                    get(risk, 'paymentId'),
                    SHEETS.SUMMARY_SHEET,
                  ),
                ) && (
                  <AssignmentIcon
                    className="consult"
                    onClick={openDocument(
                      getCurrentSheet(
                        regulations,
                        get(risk, 'paymentId'),
                        SHEETS.SUMMARY_SHEET,
                      ),
                    )}
                  />
                )}
              </TableCell>
              <TableCell>
                {get(risk, 'recipient', '').includes('CNRA')
                  ? !isNil(
                      getCurrentSheet(
                        regulations,
                        get(risk, 'paymentId'),
                        SHEETS.CNRA_SHEET,
                      ),
                    ) && (
                      <AssignmentIcon
                        className="consult"
                        onClick={openDocument(
                          getCurrentSheet(
                            regulations,
                            get(risk, 'paymentId'),
                            SHEETS.CNRA_SHEET,
                          ),
                        )}
                      />
                    )
                  : get(risk, 'recipient', '').includes('CDRA') &&
                    !isNil(
                      getCurrentSheet(
                        regulations,
                        get(risk, 'paymentId'),
                        SHEETS.CDRA_SHEET,
                      ),
                    ) && (
                      <AssignmentIcon
                        className="consult"
                        onClick={openDocument(
                          getCurrentSheet(
                            regulations,
                            get(risk, 'paymentId'),
                            SHEETS.CDRA_SHEET,
                          ),
                        )}
                      />
                    )}
              </TableCell>
              {featureService.hasFeature(
                FEATURES.REGULATION_WORKFLOW_VALIDATION,
              ) && (
                <TableCell>
                  <div
                    data-testId="recap-btn"
                    onClick={() => {
                      setPaymentId(get(risk, 'paymentId', ''));
                      setOpenRecap(true);
                    }}
                  >
                    {get(risk, 'documentChiffre', {}) &&
                      !isSagisRegulation(get(risk, 'paymentId', '')) && (
                        <DetailsIcon
                          className="consult"
                          style={{ cursor: 'pointer' }}
                        />
                      )}
                  </div>
                </TableCell>
              )}
            </TableRow>
          </TableBody>
        );
      })}
    </Table>
  );
};

export default RegulationTable;
